export default "__VITE_ASSET__D30xmWHh__"